module.exports = __webpack_public_path__ + "static/img/time.c62ed6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time.png
// module id = qKtB
// module chunks = 1